import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "border border-gray-200 rounded-lg p-4 py-2 mb-4 bg-white animate-pulse" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-start gap-4 col-span-1\"><div class=\"flex flex-col gap-1 w-full\"><div class=\"h-3 bg-slate-200 rounded w-1/2\"></div><div class=\"h-4 bg-slate-200 rounded w-3/4\"></div></div><div class=\"h-12 w-[1px] bg-gray-200 hidden sm:block\"></div></div><div class=\"flex flex-col gap-1 col-span-1\"><div class=\"h-3 bg-slate-200 rounded w-1/3\"></div><div class=\"h-6 bg-slate-200 rounded-full w-24\"></div></div><div class=\"flex flex-col gap-1 col-span-1\"><div class=\"h-3 bg-slate-200 rounded w-1/3\"></div><div class=\"h-4 bg-slate-200 rounded w-3/4\"></div><div class=\"h-3 bg-slate-200 rounded w-1/2\"></div></div><div class=\"flex flex-col gap-1 col-span-1\"><div class=\"h-3 bg-slate-200 rounded w-1/4\"></div><div class=\"h-4 bg-slate-200 rounded w-full\"></div><div class=\"h-3 bg-slate-200 rounded w-2/3\"></div></div><div class=\"flex flex-col gap-1 col-span-1\"><div class=\"h-3 bg-slate-200 rounded w-1/2\"></div><div class=\"h-4 bg-slate-200 rounded w-1/2\"></div></div>", 5)
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col gap-1 col-span-1"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"h-3 bg-slate-200 rounded w-1/2\"></div><div class=\"flex gap-1\"><div class=\"h-5 w-5 bg-slate-200 rounded-full\"></div><div class=\"h-5 w-5 bg-slate-200 rounded-full\"></div><div class=\"h-5 w-5 bg-slate-200 rounded-full\"></div></div>", 2)
const _hoisted_10 = [
  _hoisted_8
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 flex items-end justify-start sm:justify-end w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-8 bg-slate-200 rounded w-[160px]" })
], -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'AuditoriumExceptionalitiesCardSkeleton',
  props: {
    showApprovalProgress: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'grid grid-cols-1 gap-4 sm:gap-6 items-center',
        _ctx.showApprovalProgress ? 'sm:grid-cols-7' : 'sm:grid-cols-6'
      ])
    }, [
      _hoisted_2,
      (_ctx.showApprovalProgress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
        : _createCommentVNode("", true),
      _hoisted_11
    ], 2)
  ]))
}
}

})